












import { Component, Vue, Prop } from 'vue-property-decorator';
import SolutionForm from './components/solutionForm.vue';
import { pubsub, CLOSE_TAG_VIEW_EVENT } from '@/utils/pubsub';
import { solutionListInstance } from '@/model/SolutionListClass';

type IClauseOption = ISolution.IClauseOption;
type IUpdateQuotationParams = ISolution.IRequest.IUpdateQuotationParams;

@Component({
  components: {
    SolutionForm,
  },
})
export default class UpdateSolution extends Vue {
  private solutionListInstance = solutionListInstance;
  get solution() {
    return this.solutionListInstance.editItem;
  }
  get requireClauses(): IClauseOption[] {
    return solutionListInstance.requireClauses;
  }
  get solutionInfoForUpdate() {
    const result = solutionListInstance.createSolution();
    if (this.solution) {
      const {
        title,
        requirementId,
        items,
        startDate,
        endDate,
        workDays,
        effectiveDays,
        effectiveDate,
      } = this.solution;
      Object.assign(result, {
        title,
        requirementId,
        items,
        startDate,
        endDate,
        workDays,
        effectiveDays,
        effectiveDate,
      });
    }
    return result;
  }
  private created() {
    solutionListInstance.requestCategorys();
  }
  private changeSolution(params: IUpdateQuotationParams): Promise<string> {
    return new Promise((reslove, reject) => {
      if (!this.solution) {
        reject('Error');
        return;
      }
      solutionListInstance
        .requestChangeItem(this.solution, params)
        .then((res) => {
          reslove(res);
          this.goListPage();
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
  private goListPage() {
    pubsub.publish(CLOSE_TAG_VIEW_EVENT, this.$route.path);
    this.$router.push({ name: 'Solution' });
  }
}
